import { render, staticRenderFns } from "./IframeWidget.vue?vue&type=template&id=1a5c915c&scoped=true&"
import script from "./IframeWidget.vue?vue&type=script&lang=js&"
export * from "./IframeWidget.vue?vue&type=script&lang=js&"
import style0 from "./IframeWidget.vue?vue&type=style&index=0&id=1a5c915c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c915c",
  null
  
)

export default component.exports